var keyMirror = require('keymirror');

module.exports = keyMirror({
    EDIT_NOTIFICATIONS: null,
    EDIT_LOCATION: null,
    UPDATE_NOTIFICATIONS: null,
    UPDATE_LOCATION_EDIT: null,
    GET_EDIT_NOTIFICATIONS_FILTER: null
});